import {APP_URL,USER_CURRENT_API,REDIRECT_URL} from '../Config/AppConfiguration';
import axios from 'axios';
import Cookies from 'universal-cookie';
import Login from '../Components/_Authentication/Login';

class UserService{

    getAccesssToken(){ 
        const cookies = new Cookies();
        var BEARER_TOKEN = 'Bearer '.concat( cookies.get("accessToken")); 
        return BEARER_TOKEN;
    }
    getuserDetails(){
        return  axios.get(USER_CURRENT_API, { headers: {'Content-Type': 'application/json'},withCredentials: true})
    }

    logoutUserold(){
         const URL=APP_URL.concat('/oauth2/logout');
         return  axios.post(URL,{},{ headers: {'Content-Type': 'application/json'} ,withCredentials: true})
     }

    logoutUser(){
        const redirectUri = encodeURIComponent(REDIRECT_URL);
        const logoutUrl = APP_URL.concat(`/oauth2/logout?post_logout_redirect_uri=${redirectUri}`);
        window.location.href = logoutUrl;
    }

     getUserProfileNotification(){
        const URL=USER_CURRENT_API.concat('/properties');
        return  axios.get(URL, { headers: {'Content-Type': 'application/json','token': new Cookies().get("accessToken")} ,withCredentials: true})
     }

enableNotification(itemName, requestData){  
    const URL=USER_CURRENT_API.concat('/properties/').concat(itemName);
    return  axios.put(URL,requestData,{ headers: {'Content-Type': 'application/json','token': new Cookies().get("accessToken")} ,withCredentials: true})
}
getStrongConfirmationCode(authURL,httpVerbData)
{
    const URL=APP_URL.concat('/getStrongConfirmationCode')
return  axios.post(URL,{authorizationUrl:authURL,httpVerb:httpVerbData},{ headers: {'Content-Type': 'application/json'} ,withCredentials: true})
}

deleteUserAccount(confirmationCode){
return  axios.delete(USER_CURRENT_API+'/',{ headers: {'Content-Type': 'application/json','X-StrongConfirmationCode':confirmationCode} ,withCredentials: true})

}

updateMobileNumber(userDetailsObject){
    const URL=USER_CURRENT_API.concat('/newmobile')
    return axios.put(URL,userDetailsObject,{ headers: {'Content-Type': 'application/json'} ,withCredentials: true});
}
activateMobileNumber(xCode){
    const URL=USER_CURRENT_API.concat('/activatenewmobile')
    return axios.post(URL,{},{ headers: {'Content-Type': 'application/json','X-StrongConfirmationCode':xCode} ,withCredentials: true});           
}
changeUserDisplayName(userDetailsObject){
    const URL=USER_CURRENT_API.concat('/displayname')
    return axios.put(URL,userDetailsObject,{ headers: {'Content-Type': 'application/json'} ,withCredentials: true});
}

changeUserPasswordFromProfilePage(userDetailsObject, xCode){
    const URL=USER_CURRENT_API.concat('/password')
    return axios.put(URL,userDetailsObject,{ headers: {'Content-Type': 'application/json; charset=utf-8','X-StrongConfirmationCode':xCode} ,withCredentials: true});
}

activateUserAccount(){
    const URL=USER_CURRENT_API.concat('/activate')
    return axios.post(URL,{},{ headers: {'Content-Type': 'application/json'} ,withCredentials: true});
}

async refereshUser(){
    const cookieNameCurrentUser = "currentAPIMUser";
    await this.getuserDetails().then((response) => {
      var tokenExpiry='';
      const cookies = new Cookies();
  if(cookies!==null){
    var _user_attributes = cookies.get(cookieNameCurrentUser);
  if (_user_attributes) {
    _user_attributes = decodeURI(_user_attributes);
    const user_attributes = JSON.parse(_user_attributes);
    tokenExpiry = user_attributes.accessTokenExpiry;
  }}
      const cookieNameUser = "userId";
      var _user_object = Login.setCurrentUserObject(response.data,tokenExpiry);
      _user_object = encodeURI(JSON.stringify(_user_object));
     // cookies.remove(cookieNameCurrentUser);
        cookies.set(cookieNameCurrentUser,_user_object,{path: '/'});
        cookies.set(cookieNameUser, response.data.email,{path: '/'});
      })
      .catch(error =>{
        console.log(error.status);
      });
  }

}
export default new UserService();
